<script>
import Vue from 'vue'

import Common from '../../../../common/Common.vue'
import Endpoints from '../../../../common/Endpoints.vue'
import Request from '../../../../common/Request.vue'
import Services from '../../../../common/Services.vue'
import moment from 'moment-timezone'

Vue.prototype.$registerEvent = new Vue()

export default {
    init: async payload => {
        if (!payload.isSuperAdminMaster) {
            payload.data.account = await Common.getAccountId(payload)
        }
    },
    methods: {
        formatDateOnly(value) {
            if (!value) {
                return ''
            }

            if (typeof value === 'string') {
                return value.slice(0, 10)
            }

            if (value instanceof Date) {
                return value.toISOString().slice(0, 10)
            }

            if (typeof value?.toISOString === 'function') {
                return value.toISOString().slice(0, 10)
            }

            return String(value).slice(0, 10)
        },
        formatAppointmentDate(value) {
            if (!value) return ''
            const date = moment.tz(value, Common.getAccountTimezone())
            return date.isValid() ? date.format('YYYY-MM-DD') : ''
        },
        checkRequiredField(field) {
            return this.errors.includes(field)
        },
        removeRequiredField(field) {
            this.errors = this.errors.filter(item => item !== field)
        },
        isValidBeginDate(event) {
            const dateString = event?.target?.value

            if (dateString.length > 10) {
                this.data.beginDate = dateString.substring(0, 10)
            }

            if (dateString.length === 10) {
                this.data.beginDate = dateString
            }
        },
        isValidEndDate(event) {
            const dateString = event?.target?.value

            if (dateString.length > 10) {
                this.data.endDate = dateString.substring(0, 10)
            }

            if (dateString.length === 10) {
                this.data.endDate = dateString
            }
        },
        changeAccount: async function () {
            this.siteList = []
            this.data.client = ''
            this.data.site = ''

            const account = this.data.account
            this.clientList = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.data.client

            if (!client || client === '') {
                this.data.site = ''
            }

            this.siteList = await Services.getSitesByClient(this, client)
        },
        changeSite: async function () {
            this.equipmentList = await Services.getEquipmentsBySite(this, this.data) // Carrega equipamentos do site selecionado
            this.data.equipment = ''
        },
        resetAlertportWriteKeys() {
            this.alertportWriteKeys = {}
        },
        getAlertportWriteHeaders(scope) {
            if (!this.alertportWriteKeys) this.resetAlertportWriteKeys()
            if (!this.alertportWriteKeys[scope]) {
                const random = new Uint32Array(4)
                window.crypto.getRandomValues(random)
                this.alertportWriteKeys[scope] = `alertport-${Array.from(random, value => value.toString(16).padStart(8, '0')).join('')}`
            }
            return { ...Request.getDefaultHeader(this), 'x-idempotency-key': this.alertportWriteKeys[scope] }
        },
        async save() {
            if (this.isSaveLoading) return false
            this.isSaveLoading = true
            try {
                const object = JSON.parse(JSON.stringify(this.data))
                const response = await Request.do(this, 'POST', this.getAlertportWriteHeaders('create'), object, Endpoints.schedules.alertports.alertport)
                const syncPending = response?.status === 202 && response?.data?.status === 202 && response?.data?.syncPending === true
                const synchronized = response?.status === 200 && response?.data?.status === 200
                if (!synchronized && !syncPending) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.create.error'))
                    return false
                }
                Common.show(this, 'bottom-right', syncPending ? 'warn' : 'success', this.$t(syncPending ? 'str.form.create.sync.pending' : 'str.form.create.success'))
                this.$registerEvent.$emit('refreshSchedule')
                await this.closeModal()
                return true
            } catch (_error) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.create.error'))
                return false
            } finally {
                this.isSaveLoading = false
            }
        },
        buildAlertportUpdatePayload(occurrence = false) {
            const data = JSON.parse(JSON.stringify(this.data))
            const payload = {
                schedule: data.schedule?._id || data.schedule || data._id,
                category: 'ALERT_CHECK',
                alertOccurrence: true,
            }
            const fields = ['name', 'description', 'account', 'client', 'site', 'equipment', 'beginDate', 'endDate', 'beginHour', 'endHour', 'alertConfig']
            if (!occurrence) fields.push('frequency', 'weeklyDays', 'frequencyMonth', 'frequencyYear', 'noEndDate')
            fields.forEach(field => {
                if (data[field] !== undefined) payload[field] = data[field]
            })
            if (occurrence) payload.appointment = data.appointment?._id || data.appointment
            return payload
        },
        async executeAlertportUpdate(endpoint, occurrence = false) {
            if (this.isSaveLoading) return false
            this.isSaveLoading = true
            try {
                const response = await Request.do(this, 'POST', this.getAlertportWriteHeaders(occurrence ? 'occurrence' : 'series'), this.buildAlertportUpdatePayload(occurrence), endpoint)
                const syncPending = response?.status === 202 && response?.data?.status === 202 &&
                    (response?.data?.syncPending === true || (occurrence && response?.data?.result?.syncPending === true))
                const synchronized = response?.status === 200 && response?.data?.status === 200
                if (!synchronized && !syncPending) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.update.generic.error'))
                    return false
                }
                if (syncPending) Common.show(this, 'bottom-right', 'warn', this.$t('str.form.update.sync.pending'))
                this.$registerEvent.$emit('refreshSchedule')
                await this.closeModal()
                return true
            } catch (_error) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.update.generic.error'))
                return false
            } finally {
                this.isLoading = false
                this.isSaveLoading = false
            }
        },
        async update() {
            return await this.executeAlertportUpdate(Endpoints.schedules.alertports.update)
        },
        async updateOccurrence() {
            return await this.executeAlertportUpdate(Endpoints.appointments.alertportUpdateOccurrence, true)
        },
        async checkForm() {
            this.errors = [];

            if (!this.data.account || this.data.account === '') {
                this.errors.push('account')
            }
            if (!this.data.client || this.data.client === '') {
                this.errors.push('client')
            }
            if (!this.data.site || this.data.site === '') {
                this.errors.push('site')
            }
            if (!this.data.name || this.data.name === '') {
                this.errors.push('name')
            }
            if (!this.data.beginDate || this.data.beginDate === '') {
                this.errors.push('beginDate')
            }
            if (!this.data.endDate || this.data.endDate === '') {
                this.errors.push('endDate')
            }
            if (!this.data.frequency || this.data.frequency === '') {
                this.errors.push('frequency')
            }
            if (!this.data.beginHour || this.data.beginHour === '') {
                this.errors.push('beginHour')
            }
            if (!this.data.endHour || this.data.endHour === '') {
                this.errors.push('endHour')
            }
            if (!this.data.equipment || this.data.equipment === '') {
                this.errors.push('equipment')
            }
            if (!this.data.alertConfig.alertType) {
                this.errors.push('alertType')
            }
            if (this.data.alertConfig.alertType === 'FIXED') {
                if (!this.data.alertConfig.fixedInterval || this.data.alertConfig.fixedInterval < 1) {
                    this.errors.push('fixedInterval')
                }
            } else if (this.data.alertConfig.alertType === 'RANDOM') {
                if (!this.data.alertConfig.randomMin || this.data.alertConfig.randomMin < 1) {
                    this.errors.push('randomMin')
                }
                if (!this.data.alertConfig.randomMax || this.data.alertConfig.randomMax < 1) {
                    this.errors.push('randomMax')
                }
                if (
                    this.data.alertConfig.randomMin &&
                    this.data.alertConfig.randomMax &&
                    this.data.alertConfig.randomMax < this.data.alertConfig.randomMin
                ) {
                    this.errors.push('randomMax')
                }
            }
            if (
                this.data.alertConfig.volumeLevel === null ||
                this.data.alertConfig.volumeLevel < 0 ||
                this.data.alertConfig.volumeLevel > 100
            ) {
                this.errors.push('volumeLevel')
            }

            if (this.errors.length > 0) 
                return

            if (this.updateSchedule) return await this.update()
            if (this.updateAppointment) return await this.updateOccurrence()
            return await this.save()
        },
        checkRangeDate: async function () {
            if (this.data.beginDate && this.data.endDate) {
                const beginDate = moment(this.data.beginDate)
                const endDate = moment(this.data.endDate)

                if (!beginDate.isValid() || !endDate.isValid()) {
                    // Invalid date format
                    Common.show(this, 'bottom-right', 'warn', 'Invalid date format')
                    return false
                }

                if (beginDate.isAfter(endDate)) {
                    // begin date is greater than end date
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.schedule.error.begin.date.greater.than.end.date'))
                    return false
                }
                return true
            }
            return false
        },
        confirmEdit: async function () {
            this.$swal({
                title: this.$t('str.are.you.sure'),
                text: this.$t('str.are.you.sure.edit.schedule'),
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: this.$t('str.title.edit.series'),
                cancelButtonClass: 'btn btn-default min-btn-width',
                denyButtonText: this.$t('str.title.edit.occurrence'),
                confirmButtonClass: 'btn me-5px btn-danger min-btn-width',
                cancelButtonText: this.$t('str.btn.exit'),
                denyButtonClass: 'btn me-5px btn-warning min-btn-width',
            }).then(result => {
                if (result.isConfirmed) {
                    this.updateAppointmentSeries()
                } else if (result.isDenied) {
                    this.updateAppointmentOccurrence()
                }
            })
        },
        updateAppointmentSeries: async function () {
            this.resetAlertportWriteKeys()
            const newData = JSON.parse(JSON.stringify({ ...this.data, ...this.seriesDetails }))

            newData.schedule = newData._id
            delete newData._id

            if (!this.isPastDate) {
                newData.beginDate = this.formatAppointmentDate(this.data?.appointment?.startDate || this.data?.appointment?.start)
            }

            this.data = newData
            this.updateSchedule = true
        },
        updateAppointmentOccurrence: async function () {
            this.resetAlertportWriteKeys()
            const newData = JSON.parse(JSON.stringify(this.data))

            newData.schedule = this.data._id

            delete newData._id

            newData.beginDate = this.formatAppointmentDate(this.data?.appointment?.startDate || this.data?.appointment?.start)
            newData.endDate = this.formatAppointmentDate(this.data?.appointment?.startDate || this.data?.appointment?.start)

            newData.beginHour = this.data?.appointment?.startHour
            newData.endHour = this.data?.appointment?.endHour
           
            this.data = newData
            this.updateAppointment = true
        },
        confirmArchive() {
            this.$swal({
                title: this.$t('str.are.you.sure'),
                text: this.$t('str.are.you.sure.delete.schedule'),
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: this.$t('str.title.delete.series'),
                cancelButtonClass: 'btn btn-default min-btn-width',
                denyButtonText: this.$t('str.title.delete.occurrence'),
                confirmButtonClass: 'btn me-5px btn-danger min-btn-width',
                cancelButtonText: this.$t('str.btn.exit'),
                denyButtonClass: 'btn me-5px btn-warning min-btn-width',
            }).then(result => {
                if (result.isConfirmed) {
                    this.cancelAppointmentSeries()
                } else if (result.isDenied) {
                    this.cancelAppointmentOccurrence()
                }
            })
        },
        async executeAlertportCancellation(endpoint, filters, scope) {
            if (this.isLoading) return false
            this.isLoading = true
            try {
                const headers = {
                    ...Request.getDefaultHeader(this),
                    'x-idempotency-key': `cancel-${scope}-${filters.schedule}-${filters.appointment || filters.startDate}`,
                }
                const response = await Request.do(this, 'POST', headers, filters, endpoint)
                const syncPending = response?.status === 202 && response?.data?.status === 202 && response?.data?.syncPending === true
                const synchronized = response?.status === 200 && response?.data?.status === 200
                if (!synchronized && !syncPending) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                    return false
                }
                if (syncPending) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.sync.pending'))
                    this.$registerEvent.$emit('refreshSchedule')
                    await this.closeModal()
                } else {
                    this.$registerEvent.$emit('cancelAppointment')
                }
                return true
            } catch (_error) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                return false
            } finally {
                this.isLoading = false
            }
        },
        async cancelAppointmentSeries() {
            return await this.executeAlertportCancellation(Endpoints.appointments.alertportCancelSeries, {
                schedule: this.data._id,
                startDate: moment().tz(Common.getAccountTimezone()).format('YYYY-MM-DD'),
            }, 'series')
        },
        async cancelAppointmentOccurrence() {
            return await this.executeAlertportCancellation(Endpoints.appointments.alertportCancelOccurrence, {
                schedule: this.data._id,
                appointment: this.data.appointment?._id || this.data.appointment,
            }, 'occurrence')
        },
        changeFrequency: function () {
            this.data.frequencyYear = {
                month: '',
                day: '',
            }
            this.data.frequencyMonth = {
                day: '',
            }
            this.data.weeklyDays = []
            this.removeRequiredField('frequencyMonthDay')
            this.removeRequiredField('frequencyYearMonth')
            this.removeRequiredField('frequencyYearDay')
            this.removeRequiredField('rangeDate')
        },
         closeModal() {
            this.resetAlertportWriteKeys()
            this.errors = []

            this.isPastDate = false
            this.updateSchedule = false
            this.updateAppointment = false

            this.$bvModal.hide('createScheduleModal')
        },
       
        verifyDay: function () {
            // check if day of month is valid for selected month
            const month = this.data?.frequencyYear?.month
            const day = this.data?.frequencyYear?.day

            if (month && day) {
                const daysInMonth = new Date(new Date().getFullYear(), month, 0).getDate()
                if (day > daysInMonth) {
                    this.data.frequencyYear.day = daysInMonth
                }
            }
        },
        clearErrorDate: function (name) {
            this.removeRequiredField(name)
            this.removeRequiredField('rangeDate')
        },
        verifyMonthDay: function () {
            // check if day of month is valid for selected month
            const day = this.data?.frequencyMonth?.day
            if (day > 31) {
                this.data.frequencyMonth.day = 31
            }
        },
        async initSelectedAppointment() {
            this.resetAlertportWriteKeys()
            this.isLoading = true

            try {
                const source = this.selectedAppointment?._id ? this.selectedAppointment : this.data
                this.seriesDetails = JSON.parse(JSON.stringify({
                    beginDate: this.formatDateOnly(source.beginDate),
                    endDate: this.formatDateOnly(source.endDate),
                    beginHour: source.beginHour,
                    endHour: source.endHour,
                    equipment: source.equipment?._id || source.equipment,
                    alertConfig: source.alertConfig,
                }))
                this.data.account = this.data?.account?._id || this.data.account
                this.data.client = this.data?.client?._id || this.data.client
                this.data.site = this.data?.site?._id || this.data.site
                this.data.equipment = this.data?.equipment?._id || this.data.equipment
                this.appointment = this.data?.appointment

                this.data.beginDate = this.formatDateOnly(this.data?.beginDate)
                this.data.endDate = this.formatDateOnly(this.data?.endDate)

                const start = this.appointment?.startDate || this.appointment?.start
                const end = this.appointment?.endDate || this.appointment?.end
                if (start) {
                    this.data.beginDate = this.formatAppointmentDate(start)
                    this.data.beginHour = moment.tz(start, Common.getAccountTimezone()).format('HH:mm')
                }
                if (end) {
                    this.data.endDate = this.formatAppointmentDate(end)
                    this.data.endHour = moment.tz(end, Common.getAccountTimezone()).format('HH:mm')
                }
                if (this.appointment?.equipment) this.data.equipment = this.appointment.equipment?._id || this.appointment.equipment
                if (this.appointment?.alertConfig) this.data.alertConfig = JSON.parse(JSON.stringify(this.appointment.alertConfig))

                const appointmentDay = this.formatAppointmentDate(this.appointment?.startDate || this.appointment?.start)
                this.isPastDate = Boolean(appointmentDay && appointmentDay < moment().tz(Common.getAccountTimezone()).format('YYYY-MM-DD'))

                if (Common.isSuperAdminMaster(this)) {
                    this.accountList = await Services.getAccounts(this)
                }

                this.clientList = await Services.getClientsByAccount(this, this.data.account)
                this.siteList = await Services.getSitesByClient(this, this.data.client)
                this.equipmentList = await Services.getEquipmentsBySite(this, this.data)


                this.isLoading = false
            } catch {
                this.isLoading = false
            }
        },
    },
}
</script>
